module.exports = __webpack_public_path__ + "files/SOS Strategy Clarification Workshop 2.9ded84b5.pdf";